export default __webpack_public_path__ + "static/media/banner2.18921740.jpg";